import styled from "styled-components";

const InnerContentWrapper = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 5rem;
  position: relative;
  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    padding: 2rem 0;
    width: ${props => props.theme.contentWidth.tablet};
  }
  @media (max-width: ${props => props.theme.breakPoints.mobile}) {
    padding: 2rem 1rem;
    width: 100%;
  }

  .innerPadding {
    padding: 2rem;
    @media (max-width: ${props => props.theme.breakPoints.mobile}) {
      padding: 1rem;
    }
  }
`;

export default InnerContentWrapper;
